<template>
  <div v-show="show" class="loading-mask">
    <div class="loading-spinner"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LoadingMask',
  computed: {
    ...mapState({
      show: state => state.loading.show
    })
  }
}
</script>

<style scoped lang="scss">
.loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style> 